import type { RouteMapItem } from "../types/routes";

// route.coordinates - [lng, lat, elevation?] на точку (порядок GeoJSON).
// Обычный цикл вместо reduce() - обход известной проблемы TS с перегрузками
// для tuple-аккумуляторов.
export const routeCentroid = (route: Pick<RouteMapItem, "coordinates"> | null) => {
  const coords = route?.coordinates || [];
  if (!coords.length) return null;
  let sumLat = 0;
  let sumLng = 0;
  for (const p of coords) {
    sumLng += p[0];
    sumLat += p[1];
  }
  return { lat: sumLat / coords.length, lng: sumLng / coords.length };
};
